<template>
    <hr :style="style"/>
</template>
<script>
import Colorable from '../../mixins/Colorable';

export default {
    name: 'Divider',
    mixins: [Colorable],
    computed: {
        style () {
            return {
                backgroundColor: this.color,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
hr {
    border: none;
    width: 64px;
    height: 4px;
    margin: 10px auto;
}
</style>
